/* Best Home Fashion theme JS — cart drawer, variants, gallery, nav */
(function () {
  var routes = window.BHF_ROUTES || {};

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function money(cents) {
    var f = window.BHF_MONEY_FORMAT || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mnav-open]');
    if (open) { $('.mnav').classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-mnav-close]')) { $('.mnav').classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* ---------- header search drawer ---------- */
  (function () {
    var wrap = $('[data-search-drawer]');
    var toggle = $('[data-search-toggle]');
    if (!wrap || !toggle) return;

    var input = $('[data-search-input]', wrap);
    var panel = $('[data-search-results]', wrap);
    var form = wrap.querySelector('form');
    var timer, controller;
    var lastTerm = '';

    function isOpen() { return wrap.classList.contains('is-open'); }

    function openSearch() {
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      /* the drawer is visibility:hidden until the class is applied, and a
         hidden field refuses focus — wait for the next frame */
      window.requestAnimationFrame(function () { input.focus(); input.select(); });
    }

    function closeSearch(refocus) {
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      clearPanel();
      if (refocus) toggle.focus();
    }

    function clearPanel() {
      window.clearTimeout(timer);
      if (controller) { controller.abort(); controller = null; }
      lastTerm = '';
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    /* results ---------------------------------------------------------- */
    function results() { return $$('[data-search-result]', panel); }

    function active() { return $('.is-active', panel); }

    function highlight(el) {
      var cur = active();
      if (cur) cur.classList.remove('is-active');
      if (!el) { input.removeAttribute('aria-activedescendant'); return; }
      el.classList.add('is-active');
      if (!el.id) el.id = 'hsr-' + results().indexOf(el);
      input.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function step(dir) {
      var items = results();
      if (!items.length) return;
      var i = items.indexOf(active());
      i = i < 0 ? (dir > 0 ? 0 : items.length - 1) : i + dir;
      if (i < 0 || i >= items.length) { highlight(null); return; }
      highlight(items[i]);
    }

    function fetchSuggestions(term) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = (routes.predictive_search || '/search/suggest') +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page,article&resources[limit]=5' +
        '&section_id=predictive-search';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          /* a stale response can land after the shopper kept typing */
          if (term !== lastTerm || !isOpen()) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-panel]');
          if (!fresh) { panel.hidden = true; return; }
          panel.innerHTML = '';
          panel.appendChild(fresh);
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          highlight(null);
        })
        .catch(function () { /* aborted or offline — leave the last panel alone */ });
    }

    /* events ----------------------------------------------------------- */
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen()) closeSearch(false); else openSearch();
    });

    input.addEventListener('input', function () {
      var term = input.value.trim();
      window.clearTimeout(timer);
      if (term.length < 2) { clearPanel(); return; }
      lastTerm = term;
      timer = window.setTimeout(function () { fetchSuggestions(term); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); step(-1); }
      else if (e.key === 'Enter') {
        var sel = active();
        if (sel) { e.preventDefault(); window.location.href = sel.href; }
      }
    });

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(true); }
    });

    form.addEventListener('submit', function () { clearPanel(); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      /* first Escape drops the suggestions, second closes the drawer */
      if (!panel.hidden) clearPanel(); else closeSearch(true);
    });

    document.addEventListener('mousedown', function (e) {
      if (!isOpen()) return;
      if (wrap.contains(e.target) || toggle.contains(e.target)) return;
      closeSearch(false);
    });

    /* opening the mobile nav or the cart shouldn't leave the drawer hanging */
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (e.target.closest('[data-mnav-open]') || e.target.closest('[data-cart-open]')) closeSearch(false);
    });
  })();

  /* ---------- cart drawer ---------- */
  function drawer() { return $('#cart-drawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.add('is-open'); document.body.style.overflow = 'hidden';
    var x = d.querySelector('.drawer__x'); if (x) x.focus();
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    /* the quick-add picker sits on top of everything — it goes first, alone */
    if (quickIsOpen()) { closeQuick(true); return; }
    closeDrawer();
    var m = $('.mnav'); if (m) m.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  function refreshDrawer() {
    return fetch((routes.cart || '/cart') + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#cart-drawer');
        var cur = drawer();
        if (fresh && cur) {
          var wasOpen = cur.classList.contains('is-open');
          cur.innerHTML = fresh.innerHTML;
          if (wasOpen) cur.classList.add('is-open');
        }
        return fetch((routes.cart || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }

    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-cart-remove'), 0); }

    var step = e.target.closest('[data-cart-step]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-line'), parseInt(step.getAttribute('data-qty'), 10));
    }

    var add = e.target.closest('[data-quick-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-quick-add'), 1, add); }

    var pick = e.target.closest('[data-quick-pick]');
    if (pick) { e.preventDefault(); openQuick(pick.getAttribute('data-quick-pick'), pick); }

    if (e.target.closest('[data-quick-close]')) { e.preventDefault(); closeQuick(true); }

    var qatc = e.target.closest('[data-quick-atc]');
    if (qatc) {
      e.preventDefault();
      var vid = qatc.getAttribute('data-variant');
      /* close first so the cart drawer isn't revealed behind the modal */
      if (vid) addToCart(vid, 1, qatc, function () { closeQuick(false); });
    }
  });

  function changeLine(line, qty) {
    fetch((routes.cart_change || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refreshDrawer);
  }

  /* onAdded, when given, runs once the line is on the cart and before the
     drawer opens — the quick-add modal uses it to close itself first. */
  function addToCart(id, qty, btn, onAdded) {
    var label;
    if (btn) { label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    return fetch((routes.cart_add || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { return r.json(); })
      .then(function () { if (onAdded) onAdded(); return refreshDrawer(); })
      .then(function () { openDrawer(); })
      .catch(function () { })
      .then(function () { if (btn) { btn.textContent = label; btn.disabled = false; } });
  }

  /* ---------- option picker ----------
     Shared by the PDP buy box and the quick-add modal. Both render
     snippets/product-options.liquid, so both get the same variant matching and
     the same "this combination is sold out" rules from here.

     onChange runs after every paint with the matched variant, or undefined
     when the picked combination isn't a real variant. */
  function optionPicker(root, product, onChange) {
    var selected = product.options.map(function (_, i) {
      var cur = $('[data-opt-index="' + i + '"][aria-pressed="true"]', root);
      return cur ? cur.getAttribute('data-opt-value') : null;
    });

    function findVariant() {
      return product.variants.filter(function (v) {
        return selected.every(function (val, i) { return !val || v.options[i] === val; });
      })[0];
    }

    function availableFor(index, value) {
      return product.variants.some(function (v) {
        if (v.options[index] !== value) return false;
        return selected.every(function (val, i) { return i === index || !val || v.options[i] === val; }) && v.available;
      });
    }

    function paint() {
      product.options.forEach(function (_, i) {
        $$('[data-opt-index="' + i + '"]', root).forEach(function (b) {
          var val = b.getAttribute('data-opt-value');
          b.setAttribute('aria-pressed', selected[i] === val ? 'true' : 'false');
          b.disabled = !availableFor(i, val);
        });
        var out = $('[data-opt-current="' + i + '"]', root);
        if (out) out.textContent = selected[i] || '';
      });
      onChange(findVariant());
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt-index]');
      if (!b) return;
      e.preventDefault();
      selected[parseInt(b.getAttribute('data-opt-index'), 10)] = b.getAttribute('data-opt-value');
      paint();
    });

    paint();
    return { variant: findVariant, refresh: paint };
  }

  /* ---------- product form ---------- */
  function initProduct(root) {
    var data = $('[data-product-json]', root);
    if (!data) return;
    var product = JSON.parse(data.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[name="id"]', form);

    optionPicker(root, product, function (v) {
      var priceEl = $('[data-price]', root);
      var atc = $('[data-atc]', root);
      /* the sticky bar sits outside [data-product-root] so it can pin to the
         viewport for the whole page — look it up document-wide */
      var stickyPrice = $('[data-sticky-price]');
      if (v) {
        idInput.value = v.id;
        var html = money(v.price);
        if (v.compare_at_price > v.price) html += ' <s>' + money(v.compare_at_price) + '</s>';
        if (priceEl) priceEl.innerHTML = html;
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (atc) {
          atc.disabled = !v.available;
          atc.textContent = v.available ? 'Add to Cart — ' + money(v.price) : 'Sold Out';
        }
        if (v.featured_image) setMain(v.featured_image.src);
        if (history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      } else if (atc) {
        atc.disabled = true; atc.textContent = 'Unavailable';
      }
    });

    /* qty */
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-qty-step]');
      if (!s) return;
      e.preventDefault();
      var input = $('[name="quantity"]', form);
      var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(s.getAttribute('data-qty-step'), 10));
      input.value = n;
    });

    /* gallery */
    function setMain(src) {
      var main = $('[data-gal-main] img', root);
      if (main && src) main.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
    }
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-gal-th]');
      if (!th) return;
      e.preventDefault();
      $$('[data-gal-th]', root).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      th.setAttribute('aria-current', 'true');
      setMain(th.getAttribute('data-src'));
    });

    /* ajax add */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qty = parseInt($('[name="quantity"]', form).value, 10) || 1;
      addToCart(idInput.value, qty, $('[data-atc]', root));
    });

    var sticky = $('[data-sticky-add]');
    if (sticky) sticky.addEventListener('click', function () {
      addToCart(idInput.value, parseInt($('[name="quantity"]', form).value, 10) || 1, sticky);
    });

    /* reveal the sticky bar once the main add-to-cart scrolls out of view */
    var bar = $('[data-sticky-bar]');
    var atcBtn = $('[data-atc]', root);
    if (bar && atcBtn && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(atcBtn);
    } else if (bar) {
      bar.classList.add('is-visible');
    }
  }
  $$('[data-product-root]').forEach(initProduct);

  /* ---------- quick add ----------
     Cards for products with more than one variant open this instead of adding
     a guessed variant. The body is real Liquid, fetched from
     sections/quick-add.liquid, so the swatches, the icons and the money format
     match the PDP exactly. */
  var qmodal, qReturnFocus, qToken = 0;

  function quickModal() {
    if (qmodal) return qmodal;
    qmodal = document.createElement('div');
    qmodal.className = 'qadd';
    qmodal.innerHTML =
      '<div class="qadd__scrim" data-quick-close></div>' +
      '<div class="qadd__panel" role="dialog" aria-modal="true" aria-label="Choose options">' +
        '<button class="qadd__x" type="button" data-quick-close aria-label="Close">&#10005;</button>' +
        '<div data-quick-content></div>' +
      '</div>';
    document.body.appendChild(qmodal);
    return qmodal;
  }

  function quickIsOpen() { return !!qmodal && qmodal.classList.contains('is-open'); }

  function closeQuick(refocus) {
    qToken++; /* a response still in flight must not paint into a closed modal */
    if (!qmodal) return;
    qmodal.classList.remove('is-open');
    /* the drawer upsell can open this from on top of an open cart drawer —
       don't hand scrolling back while that is still covering the page */
    var d = drawer();
    document.body.style.overflow = d && d.classList.contains('is-open') ? 'hidden' : '';
    $('[data-quick-content]', qmodal).innerHTML = '';
    if (refocus && qReturnFocus) qReturnFocus.focus();
    qReturnFocus = null;
  }

  function openQuick(url, btn) {
    if (!url) return;
    var m = quickModal();
    var content = $('[data-quick-content]', m);
    var mine = ++qToken;

    qReturnFocus = btn || null;
    content.innerHTML = '<p class="qadd__msg">Loading…</p>';
    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    /* the panel is visibility:hidden until the class lands, and a hidden
       element refuses focus — wait for the next frame */
    window.requestAnimationFrame(function () { $('.qadd__x', m).focus(); });

    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-add')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mine !== qToken) return;
        var body = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-quick-root]');
        if (!body) throw new Error('no picker');
        content.innerHTML = '';
        content.appendChild(body);
        initQuickPicker(body);
        var first = $('[data-opt-index]:not([disabled])', body) || $('[data-quick-atc]', body);
        if (first) first.focus();
      })
      .catch(function () {
        if (mine !== qToken) return;
        /* the product page always works — send them there rather than nowhere */
        content.innerHTML = '<p class="qadd__msg">Couldn\'t load the options. ' +
          '<a href="' + url + '">Open the product page</a></p>';
      });
  }

  function initQuickPicker(root) {
    var data = $('[data-product-json]', root);
    var atc = $('[data-quick-atc]', root);
    if (!data || !atc) return;
    var product = JSON.parse(data.textContent);
    var priceEl = $('[data-price]', root);
    var media = $('[data-quick-media] img', root);

    optionPicker(root, product, function (v) {
      if (!v) {
        atc.removeAttribute('data-variant');
        atc.disabled = true;
        atc.textContent = 'Unavailable';
        return;
      }
      atc.setAttribute('data-variant', v.id);
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to Cart — ' + money(v.price) : 'Sold Out';
      var html = money(v.price);
      if (v.compare_at_price > v.price) html += ' <s>' + money(v.compare_at_price) + '</s>';
      if (priceEl) priceEl.innerHTML = html;
      if (media && v.featured_image) {
        media.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2');
      }
    });
  }

  /* ---------- product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { });
  });

  /* ---------- collection filters + sort auto-submit ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
})();
